import { useMemo } from 'react';
import SortOption, { SortOptionsWithLabels } from '~/constants/srp/SortOption';
import { useUserDeliveryInfo } from '~/context/srp/InventoryContext';
import CheckIcon from '~/icons/srp/Check';
import {
  InventoryListButton,
  InventoryListItemWrapper,
  SortInventoryModalWrapper
} from './SortModal.styles';

function useSortOptions() {
  const { isOutOfMarket = false, isDeliveryAllowed = false } =
    useUserDeliveryInfo() ?? {};
  const isFreeShippingEligible = !isOutOfMarket && isDeliveryAllowed;

  return useMemo(
    () =>
      isFreeShippingEligible
        ? SortOptionsWithLabels
        : SortOptionsWithLabels.filter(s => s.key !== SortOption.FreeShipping),
    [isFreeShippingEligible]
  );
}

type OwnProps = {
  selectedSortByItemKey: string;
  toggleSortOrderModal: () => void;
  updateSortOrder: (key: SortOption) => void;
};

export default function SortModal({
  selectedSortByItemKey,
  toggleSortOrderModal,
  updateSortOrder
}: OwnProps) {
  const sortOptions = useSortOptions();

  const handleSelect = (key: SortOption) => {
    updateSortOrder(key);
    toggleSortOrderModal();
  };

  return (
    <SortInventoryModalWrapper tabIndex={-1}>
      {sortOptions.map(s => (
        <InventoryListItemWrapper
          key={s.key}
          data-qa={selectedSortByItemKey === s.key ? 'is-sorted-by' : undefined}
        >
          <span className="flex items-center justify-center">
            {selectedSortByItemKey === s.key && (
              <CheckIcon className="h-[14px] w-full" />
            )}
          </span>
          <InventoryListButton
            onClick={() => handleSelect(s.key)}
            disabled={selectedSortByItemKey === s.key}
            data-analytics-id="Search - Sort By - Changed"
            data-analytics-attributes={JSON.stringify({ newSortOrder: s.key })}
          >
            {s.label}
          </InventoryListButton>
        </InventoryListItemWrapper>
      ))}
    </SortInventoryModalWrapper>
  );
}
